// frontend/src/components/ContactManager.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import api from "../api/api"; // Импортируем API

function ContactManager() {
  const [name, setName] = useState("");
  const [source, setSource] = useState("");
  const [contactInfo, setContactInfo] = useState(""); // Добавляем состояние для контактной информации
  const [clientId, setClientId] = useState(null); // Состояние для хранения ID клиента
  const navigate = useNavigate();

  const handleStartChat = async () => {
    if (!name || !source || !contactInfo) {
      alert("Пожалуйста, заполните все поля.");
      return;
    }

    try {
      // Отправляем запрос для проверки или создания клиента
      const response = await api.post("/clients/", {
        full_name: name,
        source: source,
        contact_info: contactInfo, // Добавляем контактную информацию
      });

      const clientId = response.data.id;
      setClientId(clientId);
    } catch (error) {
      console.error("Ошибка при создании клиента:", error);
      alert("Произошла ошибка при создании клиента.");
    }
  };

  const goToChat = () => {
    if (clientId) {
      navigate(`/chat/${clientId}`);
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Связаться с Менеджером
      </Typography>
      <FormControl fullWidth margin="normal">
        <InputLabel id="source-label">Источник</InputLabel>
        <Select
          labelId="source-label"
          value={source}
          onChange={(e) => setSource(e.target.value)}
        >
          <MenuItem value="Avito">Avito</MenuItem>
          <MenuItem value="Сайт">Сайт</MenuItem>
          <MenuItem value="Telegram">Telegram</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Имя"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Контактная информация (телефон или email)"
        value={contactInfo}
        onChange={(e) => setContactInfo(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleStartChat}
        fullWidth
      >
        Начать чат
      </Button>
      {clientId && (
        <Button
          variant="contained"
          color="secondary"
          onClick={goToChat}
          fullWidth
          style={{ marginTop: "1rem" }}
        >
          Перейти в чат
        </Button>
      )}
    </Container>
  );
}

export default ContactManager;
